import Styles from './QuizCommon.module.scss';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Module imports.
import axios from 'axios';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

// Components import.
import { useAPI } from 'components/lib';
import { CommonQuizQuestion } from 'components/global/CommonQuizQuestion/CommonQuizQuestion';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

export function QuizCommon(props) {

    const qualityQuotient = window.location.pathname.split('/')[1] === "qq";
    const { c_quiz_id } = useParams();
    const { level_id } = useParams();
    const { qqID } = useParams();
    const { assessId } = useParams();
    const { context } = useParams();

    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [score, setScore] = useState(0);
    const [percentage, setPercentage] = useState(0);
    const [quizName, setQuizName] = useState('');
    const [apiURL, setAPIURL] = useState('');
    const [isResults, setIsResults] = useState(context === 'results');

    const { data, loading } = useAPI(apiURL, 'GET');
    const Event = require('components/lib').Event;


    useEffect(() => {
        if (context === 'results') {
            setIsResults(true);
            if (qualityQuotient) {
                setAPIURL(`/api/qq/${qqID}/results`);
            } else if (assessId) {
                setAPIURL(`/api/user/assessment/${assessId}/results`);
            } else {
                setAPIURL(`/api/c_quiz/${c_quiz_id}/level/${level_id}/results`);
            }
        }
        if (context === 'attempt') {
            if (qualityQuotient) {
                setAPIURL(`/api/qq/${qqID}/quiz`);
            } else if (assessId) {
                setAPIURL(`/api/user/assessment/${assessId}`);
            } else {
                setAPIURL(`/api/c_quiz/${c_quiz_id}/level/${level_id}/quiz`);
            }
        }
        if (context !== 'attempt' && context !== 'results') {
            navigate('/404')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qualityQuotient, isResults])

    useEffect(() => {
        if (data?.length) {
            if (isResults) {
                setQuestions(data[0].answers);
                setScore(data[0].score.pop());
                setPercentage(data[0].percentage);
                document.title = props.t('CommonQuiz.QuizCommon.title.results', { name: data[0].name });
            } else {
                setQuestions(data[0].question);
                const newSelectedAnswers = Array.from({ length: data[0].question.length }, () => -1);
                setSelectedAnswers(newSelectedAnswers);
                if (qualityQuotient) {
                    Event("qq_attempt")
                    document.title = props.t('CommonQuiz.QuizCommon.title.qq', { qqName: data[0].name });
                } 
                else if (assessId) {
                    Event("mass_attempt")
                    document.title = props.t('CommonQuiz.QuizCommon.title.assessment', { assessName: data[0].name });
                } 
                else {
                    document.title = props.t('CommonQuiz.QuizCommon.title.quiz', { qName: data[0].name })
                }
            }
            setQuizName(data[0].name);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            const message =
                props.t('CommonQuiz.QuizCommon.warning.back');
            event.returnValue = message;
            return message;
        };

        const handlePageLeave = () => {
            return props.t('CommonQuiz.QuizCommon.warning.close');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('unload', handlePageLeave);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handlePageLeave);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Functions
    const handleAnswerSelect = (orderId, questId, selectedOption) => {
        setSelectedAnswers((prevSelectedAnswers) => {
            const updatedSelectedAnswers = [...prevSelectedAnswers];

            updatedSelectedAnswers[orderId] = {
                question_id: questId,
                selectedOption: selectedOption
            };

            return updatedSelectedAnswers;
        });
    };

    const handleSubmit = () => {
        if (!isResults) {
            let formData = {};
            if (qualityQuotient) {
                console.log("adding answers with -1")
                formData = {
                    answers: selectedAnswers.map((answer, index) => {
                        if (answer - 1) {
                            return { question_id: questions[index].id, selectedOption: -1 };
                        } else {
                            return answer;
                        }
                    })
                }
            } else {
                formData = {
                    answers: selectedAnswers
                }
            }
            let endpoint;

            const isMetricAssessment = !!assessId

            switch (true) {
                case qualityQuotient:
                    endpoint = `/api/qq/${qqID}/submit`;
                    break;
                case isMetricAssessment:
                    endpoint = `/api/user/assessment/${assessId}/submit`;
                    break;
                default:
                    endpoint = `/api/c_quiz/${c_quiz_id}/level/${level_id}/submit`;
                    break;
            }

            const options = {
                method: "POST",
                url: endpoint,
                headers: {
                    "accept": "application/json",
                },
                data: formData
            };
            axios
                .request(options)
                .then(async function (response) {
                    await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
                    if (qualityQuotient) {
                        navigate(`/qq/${qqID}/results`);
                    } else if (isMetricAssessment) {
                        navigate(`/user/assessment/${assessId}/results?metricId=${response.data.data.metricId}`)
                    } else {
                        navigate(`/quizzes/${c_quiz_id}/level/${level_id}/quiz/results`);
                    }
                    setIsResults(true);
                })
                .catch((err) => {
                    console.log(err.response);
                    navigate('/oops');
                });
        }
        else {
            if (qualityQuotient) {
                navigate(`/qq`)
                return;
            }
            if (assessId) {
                const searchParams = new URLSearchParams(window.location.search);
                const metricId = searchParams.get('metricId');
                navigate(`/user/metrics/${metricId}/assessments`)
                return;
            }
            navigate(`/quizzes/${c_quiz_id}/level`)
        }
    }

    const renderTime = ({ remainingTime }) => {
        if (remainingTime === 0) {
            return <div className="timer">{props.t('CommonQuiz.QuizCommon.warning.timer')}</div>;
        }
        const minutes = Math.floor(remainingTime / 60)
        const seconds = remainingTime % 60
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');
        return `${formattedMinutes}:${formattedSeconds}`;
    }

    return (
        <>
            <div className={Styles.QuizContainer}>
                <div className={Styles.title}>
                    {qualityQuotient ?
                        props.t('CommonQuiz.QuizCommon.quiz.title.qq', { qqName: quizName }) :
                        `${quizName} ${isResults ? props.t('CommonQuiz.QuizCommon.quiz.title.results') :
                            props.t('CommonQuiz.QuizCommon.quiz.title.quiz')}`
                    }
                </div>
                {isResults && <div id='scorePercentContainer' className={Styles.scorePercentContainer}>
                    <div id='scoreContainer'
                        className={Styles.scoreContainer}
                    >
                        {props.t('CommonQuiz.QuizCommon.quiz.score', { score: score, length: questions.length })}
                    </div>
                    <div style={{
                        color: percentage < 80 ? 'red' : 'green',
                    }}
                        className={Styles.percentContainer}
                    >
                        {props.t('CommonQuiz.QuizCommon.quiz.percentage')} {percentage || 0}%
                    </div>
                </div>}
                {questions?.length ? (
                    <div id='tabsTimerContainer' className={Styles.tabsTimerContainer}>
                        {!isResults && <div id='timerContainer' className={Styles.timerContainer}>
                            <CountdownCircleTimer
                                isPlaying
                                duration={qualityQuotient ? questions?.length * 30 : 300}
                                size={80}
                                colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                                colorsTime={[180, 120, 60, 0]}
                                onComplete={handleSubmit}
                            >
                                {renderTime}
                            </CountdownCircleTimer>
                        </div>
                        }
                    </div>
                ) : (
                    <p>
                        {props.t('CommonQuiz.QuizCommon.quiz.loading')}
                    </p>
                )}
                <div className={Styles.questionContainer}>
                    {loading ?
                        <LoadingBackdrop isOpen={true} />
                        : questions.length > 0
                            ?
                            questions.map((ques, index) => {
                                return (
                                    <CommonQuizQuestion
                                        key={ques.id}
                                        question={ques}
                                        questionNumber={index + 1}
                                        onAnswerSelect={handleAnswerSelect}
                                        selectedAnswers={selectedAnswers}
                                        Results={isResults}
                                    />
                                );
                            })
                            : props.t('CommonQuiz.QuizCommon.quiz.message')
                    }
                </div>
            </div>
            <div className={Styles.submitButton}>
                <QuizButton
                    onClick={handleSubmit}
                    condition={questions?.length === 0 || (selectedAnswers.includes(-1) && !isResults)}
                    buttonText={isResults ? props.t('CommonQuiz.QuizCommon.quiz.button.next') :
                        props.t('CommonQuiz.QuizCommon.quiz.button.submit')}
                    showIcon={!isResults}
                    showResult={isResults}
                >
                </QuizButton>
            </div>
        </>

    );
}

export const QuizButton = (props) => {
    return (
        <div className={Styles.navButtonContainer}>
            <button
                className={Styles.quizButton}
                color="primary"
                disabled={props.condition}
                onClick={props.onClick}
            >
                {props.showIcon &&
                    <AssignmentTurnedInIcon fontSize="small" sx={{ marginRight: '4px' }} />}
                {props.buttonText}
            </button>
        </div>
    )
}
